export const isMerchant = (shopNumber?: number) => {
  return shopNumber === 1;
};
